import React from "react";
import { defaultFont, grayColor } from "assets/jss/material-dashboard-pro-react.js";
import SocialFacebook from "../SocialIcons/Facebook";
import SocialInstagram from "../SocialIcons/Instagram";
import SocialWhatsApp from "../SocialIcons/Whatsapp";
import WebPage from "../SocialIcons/Webpage";
import { makeStyles, Grid, Box } from '@material-ui/core';
import { blue, green, pink } from "@material-ui/core/colors";
import { IS_CRM, ENERSI_VERSION, IS_PROD } from "utils/variables";

export default function Footer(props) {
  const useStyles = makeStyles({
    footer: {
      // borderTop: "1px solid " + grayColor[15],
      // backgroundColor: '#EEEEEE',
      position: 'fixed',
      bottom: 0,
      right: 0,
      zIndex: 6,
      padding: 12,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 16,
      height: 40,
    },
    tCenter: {
      textAlign: 'center',
      ...defaultFont,
      color: '#555555',
      padding: 0,
    },
    fMargin: {
      marginBottom: 0,
    }
  });

  const classes = useStyles();
  const color = blue[800]
  const iconSize = "small";

  return (
    <footer className={`${classes.footer} gn4-footer`}>
      {IS_PROD
        ?
        <ul style={{ margin: 0, display: 'flex', gap: 8 }}>
          <li><SocialInstagram size={iconSize} color={color} /></li>
          <li><SocialFacebook size={iconSize} color={color} /></li>
          <li><SocialWhatsApp size={iconSize} color={color} /></li>
          <li><WebPage size={iconSize} color={color} /></li>
        </ul>
        : null}

      <p className={classes.fMargin}> &copy;{IS_CRM ? "CRM " : "Globalgas "}
        {1900 + new Date().getYear()}{" "} - {ENERSI_VERSION}
      </p>
    </footer>
  );
}
